import { Icon, Image, Flex } from "@chakra-ui/react";
import { NextSeo } from "next-seo";
import { FiAlertTriangle, FiMapPin } from "react-icons/fi";

import Banner from "lib/components/home/Banner";
import CTASection from "lib/components/home/CTASection";
import HowItWorksHero from "lib/components/how-it-works/HowItWorksHero";
import StepCard from "lib/components/how-it-works/StepCard";
import StepCardDark from "lib/components/how-it-works/StepCardDark";
import IntercomHelp from "lib/components/IntercomHelp";

const HowItWorks = () => {
  const scrollToBeginning = () => {
    const ele = document.querySelector("#beginning");
    if (ele) ele.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <NextSeo
        title="How It Works"
        description="Learn how Adiona Alert monitors your satellite communicator's GPS location 24/7 and delivers safety alerts directly to your Garmin inReach, ZOLEO, or Bivy Stick."
      />
      <Banner />
      <HowItWorksHero onScrollClick={scrollToBeginning} />
      <div id="beginning" />

      <StepCard
        icon={<Icon as={FiMapPin} w={10} h={10} />}
        titlePreface="We Monitor Your Location"
        title="While You're Out And About"
        paragraphs={[
          "After you have authorized us to do so, we continuously monitor the location provided by your satellite communicator so we can notify you immediately when you are in harm's way.",
        ]}
      />

      <StepCardDark
        icon={<Icon as={FiAlertTriangle} w={10} h={10} />}
        titlePreface="We Monitor Safety Alerts From"
        title="Thousands of Public Agencies"
        paragraphs={[
          "We continuously monitor the safety alerts issued by thousands of public agencies throughout Canada and the United States, ranging from weather warnings issued by the National Weather Service and Environment and Climate Change Canada, to local alerts issued by State, Provincial, Tribal, or Municipal agencies.",
          "Each alert is issued by agencies that are carefully vetted and communicated over a secure network to ensure the integrity of the alerts you receive.",
        ]}
      />

      <StepCard
        icon={
          <Flex align="center" justify="center">
            <Image
              src="/logo-orange.png"
              w="33px"
              h="40px"
              loading="lazy"
              alt="Adiona Logo"
            />
          </Flex>
        }
        titlePreface="No Matter Where You Are"
        title="We Notify You of Any Safety Alerts"
        paragraphs={[
          "Based on your location, once we identify a safety alert for your area, we immediately send your device a message so you are aware of the risks and can take precautions to stay safe.",
          "The message you receive provides you the details on the conditions that could affect your safety along with precautions and recommendations from experts. We also make sure that you know when the conditions you need to be aware of will begin and end.",
        ]}
      />

      <CTASection />
      <IntercomHelp />
    </>
  );
};

export default HowItWorks;
